import {tenant} from '../utils/tenantManager'
import { useSelector } from 'react-redux'

const useCurrent = () => {

    const authUser = useSelector(state => state.auth).user
    const currentTenantId = tenant()?._id || authUser?.tenant_id;

    const currentLangList = tenant()?.languages;

    const currentCompanyIdFromState = useSelector(state => state.currentCompany).value
    const currentCompanyId = currentCompanyIdFromState || authUser?.company_id

    const currentCompany = tenant()?.companies?.filter(company => company._id === currentCompanyId)[0]
    const currentBranches = currentCompany?.branches;

    const currentBranchId = useSelector(state => state.currentBranch).value 

    const user = authUser
    const userId = user?._id 
    const userName = user?.name 


    const currentLangId = useSelector(state => state.lang).value

    const currentSettings = useSelector(state => state.settings);

    const currentSettingsDetails = currentCompany?.settings;

    return {currentTenantId,currentCompany,currentCompanyId,currentBranches,currentBranchId,user,userId,userName,currentLangList,currentLangId,currentSettings,currentSettingsDetails}
}

export default useCurrent
